// extracted by mini-css-extract-plugin
export default {"wrap":"wG-z","fullWidth":"xG-z","hideOnDesktop":"yG-z","content":"zG-z","hasOpenedNav":"AG-z","crumbsList":"BG-z","dropdownsWrap":"CG-z"};